import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AcceptOwnerRoleDialog from './AcceptOwnerRoleDialog';
import makeGetAuthenticationInfo from 'fetches/makeGetAuthenticationInfo';
import { useData } from 'resift';
import _get from 'lodash/get';

function Container() {
  const currentUserRole = useSelector(state => _get(state, 'authentication.person.account.role'));
  const currentUserId = useSelector(state => _get(state, 'authentication.person.account.id'));
  const dispatch = useDispatch();
  const getAuthenticationInfo = makeGetAuthenticationInfo(currentUserId);
  const authenticationInfo = useData(getAuthenticationInfo);

  useEffect(() => {
    dispatch(getAuthenticationInfo());
  }, [dispatch, getAuthenticationInfo]);

  if (!authenticationInfo) {
    return <div>Loading...</div>;
  }

  const { hasSetPassword } = authenticationInfo;

  return (
    <AcceptOwnerRoleDialog
      role={currentUserRole}
      userId={currentUserId}
      hasSetPassword={hasSetPassword}
    />
  );
}

export default Container;
